import React, { useState } from "react";
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger
} from "@/components/ui/dialog";
import { FaPlusCircle } from "react-icons/fa";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { addNewWatchList, editWatchList } from "@/store/features/watchListSlice";
import { useDispatch } from "react-redux";
import { Mixpanel } from "@/elements/Mixpanel";
import { validateInput } from "@/lib/utils";
import { ErrorMessage } from "@/components/PlaceOrder/PlaceOrderMain";

const MAX_LENGTH = 15;
const META = {
    EDIT: {
        title: "Edit watchlist",
        submit: "Save"
    },
    CREATE: {
        title: "Create new watchlist",
        submit: "Create"
    }
};

export default function CreateNewWatchList({ preFillName, children, type = "CREATE", className = "", id }) {
    const [isOpen, setOpen] = useState(false);
    const [error, setError] = useState("");
    const dispatch = useDispatch();
    const [watchListName, setWatchListName] = useState(preFillName);

    const handleSave = async () => {
        try {
            if (!watchListName) {
                setError("Please enter watchlist name");
                return;
            }
            if (type === "CREATE") {
                await dispatch(addNewWatchList(watchListName)).unwrap();
            } else {
                await dispatch(editWatchList({ id, watchListName })).unwrap();
            }
            setOpen(false);
            Mixpanel.track("cta_clicked", {
                cta_text: "create_watchlist"
            });
        } catch (err) {
            setError(err.message);
        }
    };

    return (
        <Dialog
            open={isOpen}
            onOpenChange={(e) => {
                setOpen(e);
                setWatchListName(preFillName);
                setError("");
            }}
        >
            <DialogTrigger className={className}>{children}</DialogTrigger>
            <DialogContent
                className="p-6 w-[496px]"
                iconclassname="-top-3.5 right-6 bg-white p-2 rounded-full opacity-100"
            >
                <DialogHeader>
                    <DialogTitle className="text-2xl font-bold text-center">{META?.[type]?.title}</DialogTitle>
                </DialogHeader>
                <DialogDescription className="relative pb-5">
                    <Input
                        id="watchlist-name-input"
                        type="text"
                        value={watchListName}
                        onChange={(e) => {
                            if (e.target.value.length > MAX_LENGTH) {
                                setError(`Watchlist name should be less than ${MAX_LENGTH} characters`);
                            } else {
                                setWatchListName(e.target.value);
                                if (validateInput(e.target.value)) {
                                    setError("");
                                } else {
                                    setError("Watchlist name should be alphanumeric");
                                }
                            }
                        }}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" && !error) {
                                handleSave();
                            }
                        }}
                    />
                    <ErrorMessage
                        error={error?.includes("A watch list with the name") ? "Watchlist name already exists" : error}
                        className={"text-red-500 text-xs "}
                    />
                    <span className="absolute right-0 bottom-0 text-xs">
                        {watchListName?.length}/{MAX_LENGTH}
                    </span>
                </DialogDescription>
                <Button
                    disabled={error}
                    className="w-full font-bold text-base bg-[#0862BC]"
                    id="submit"
                    onClick={() => {
                        handleSave();
                    }}
                >
                    {META?.[type]?.submit}
                </Button>
            </DialogContent>
        </Dialog>
    );
}
